// *******************************************************
// Outcomes
//
// Contains contants for scoring through the app
// -------------------------------------------
export const BROCCOLI = "BROCCOLI";
export const COW = "COW";
export const DISCO = "DISCO";
export const EGG = "EGG";
export const FART = "FART";
export const HYPER = "HYPER";
export const PARTY = "PARTY";
export const POOP = "POOP";
export const SLEEP = "SLEEP";
export const VOMIT = "VOMIT";
// -------------------------------------------



// WEBPACK FOOTER //
// ./src/constants/outcomes.js